let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l8SJb")).then(() => parcelRequire('d3G6V'));